/**
 * Wraps a subscription and the assigned Observer and delegates all function calls.
 *
 * @public
 */
export class SubscriptionObserverImpl {
    constructor(observer, subscription) {
        this.observer = observer;
        this.subscription = subscription;
    }
    next(value) {
        return this.observer.next(value);
    }
    error(err) {
        return this.observer.error(err);
    }
    complete() {
        return this.observer.complete();
    }
    unsubscribe() {
        return this.subscription.unsubscribe();
    }
}
//# sourceMappingURL=SubscriptionObserver.js.map